<template>
  <Profile data-fn-location="profile" />
</template>

<script>
import Profile from '../components/templates/Profile'

export default {
  metaInfo: {
    title: 'ตั้งค่า - Finnomena'
  },
  components: {
    Profile
  }
}
</script>
